import { render } from "./FAQPage.vue?vue&type=template&id=bdee5486&scoped=true"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"

import "./FAQPage.vue?vue&type=style&index=0&id=bdee5486&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdee5486"]])

export default __exports__